/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
import DownloadIcon from '@mui/icons-material/Download';
import RefreshIcon from '@mui/icons-material/Refresh';
import UploadIcon from '@mui/icons-material/Upload';
import {
  Alert,
  Box,
  Button,
  Card,
  Chip,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Typography,
  TextField,
  useTheme,
  Tooltip,
  CircularProgress,
  Select,
  LinearProgress,
} from '@mui/material';
import { CustomDataGrid, DialogBox } from 'components';
import { colorTheme } from 'theme';
import { LoadingButton } from '@mui/lab';
import ContributionDialog from './ContributionDialog';

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { type GridColumns, type GridValidRowModel } from '@mui/x-data-grid';
import Buttons from 'components/elements/Buttons';
import { CurrencyFormaterTwoDecimals } from 'components/helpers/commonFunctions/CurrencyFormater';
import { DeleteEntryModal, YesNoModal } from 'components/shared';
import {
  commonConstantTexts,
  roles as allRoles,
  payrollFrequencyOptions,
  contributionFileStatus,
  payrollFrequencyFilterOptions,
} from 'constants/constantText';
import { strings } from 'i18n/Strings';
import { useEffect, useState, type ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  getContributionFrequency,
  getContributionFile,
  getOrganizationContributionFiles,
  getTotalContributionOfOrganization,
  uploadContributionFile,
} from 'service';
import {
  deleteContributionFile,
  exportAllOrganizationContributionFiles,
  exportMyOrganizationContributionFiles,
  getAllOrganizationContributionFiles,
} from 'service/ContributionService';
import {
  getAllRegisterOrgEmployee,
  // onboardNotifyEmployee,
} from 'service/UserService';
import { type RootState } from 'store';
import { setSnackBarFailed, setSnackBarSuccess } from 'store/snackBar';
import ContributionFileGrid from './ContributionFileGrid';
import { setOrganizationInfo } from 'store/employeeDetails';
import {
  getOrganizationDetailsOrgId,
  getOrganizationSearch,
} from 'service/EmployerService';
import {
  setCurrentPage,
  setSortBy,
  setSortOrder,
} from 'store/component/pagination';
import { checkSortingValues, formatDate } from 'utils/GeneralUtil';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import ValidateContributionFile from 'utils/readXlsxFile';

export interface TotalContribution {
  upComingContribution: number;
  totalContribution: number;
}

export interface contributionFilesType {
  id: string;
  fileName: string;
  key: string;
  payrollFrequency: string;
  period: string;
  status: string;
  uploadBy: string;
  uploadDate: string;
}

type GridRowData = Record<string, unknown>;
interface ContributionProps {
  deletedTab: boolean;
}
const ContributionFile = ({ deletedTab }: ContributionProps): JSX.Element => {
  const { roles } = useSelector((state: RootState) => state.auth);
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);
  const [openUploadOptions, setOpenUploadOptions] = useState(false);
  const [openUploadError, setOpenUploadError] = useState(false);
  const [openUploadSuboptions, setOpenUploadSubOptions] = useState(false);
  const [uploadLoader, setUploadLoader] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [orgName, setOrgName] = useState('');
  const [frequency, setFrequency] = useState<string>('');
  // const [isFirstContribution, setIsFirstContribution] =
  useState<boolean>(false);
  const [dateError, setDateError] = useState<string>('');
  // const [originalStartDate, setOriginalStartDate] = useState<string | null>();
  const [file, setFile] = useState<File | null>();
  const [totalContribution, setTotalContribution] = useState(0);
  const [upComingContribution, setUpComingContribution] = useState(0);
  const [fileUploadProgress, setFileUploadProgress] = useState(false);
  const [uploadErrorMessage, setUploadErrorMessage] = useState('');
  const [employerAdminData, setEmployerAdminData] = useState<GridRowData[]>([]);
  const [totalEntery, setTotalEntery] = useState<number>(0);
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const [showDecimalError, setShowDecimalError] = useState<boolean>(false);

  const [openDeleteFileDialog, setOpenDeleteFileDialog] =
    useState<boolean>(false);
  // const [openNotifyDialog, setOpenNotifyDialog] = useState<boolean>(false);
  const [openRemoveDialog, setOpenRemoveDialog] = useState<boolean>(false);
  const [adminContributionUpload, setOpenAdminContributionUpload] =
    useState<boolean>(false);
  const [searchLoader, setSearchLoader] = useState<boolean>(false);
  const [organizationSearch, setOrganizationSearch] = useState<string>('');
  const [adminContributionUploadError, setAdminContributionUploadError] =
    useState<string>('');
  const [organizationId, setOrganizationId] = useState<string>();

  const [downloadFormat, setDownloadFormat] = useState<boolean>(false);
  const [removeErrorData, setRemoveErrorData] = useState<any>('');
  const [contributionFileData, setContributionFileData] = useState<any>('');
  // const [notifyData, setNotifyData] = useState('');
  const [errData, setErrData] = useState<GridRowData[]>([]);
  const [finalizedData, setFinalizedData] = useState<GridRowData[]>([]);
  const [contributionFiles, setContributionFiles] = useState<
    contributionFilesType[]
  >([]);
  const [selectedContributionFile, setSelectedContributionFile] =
    useState<contributionFilesType | null>(null);
  const [isOpenContributionFileData, setIsOpenContributionFileData] =
    useState<boolean>(false);
  const [previewData, setPreviewData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pageCount, setPageCount] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const pageInfo = useSelector((state) => state?.pagination?.contributions);
  const { orgId, empId } = useSelector((state: RootState) => state.onboarding);
  const { organizationInfo } = useSelector(
    (state: RootState) => state.employeeDetails,
  );
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleSearch = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ): Promise<void> => {
    setSearchValue(event.target.value);
    dispatch(setCurrentPage({ key: 'contributions', value: 0 }));
  };

  const totalContributionOfOrganization = async (
    orgId: number,
  ): Promise<void> => {
    try {
      const res = await getTotalContributionOfOrganization(orgId);
      setTotalContribution(res.totalContribution || 0);
      setUpComingContribution(res.upComingContribution || 0);
    } catch (error) {
      console.log(error);
    }
  };

  const handleProceedAdminContributionUpload = (): void => {
    setOpenUploadOptions(true);
    setOpenAdminContributionUpload(false);
  };

  const handleSearchOrganizationDetails = async (): Promise<void> => {
    const searchValue = organizationSearch.trim();
    if (searchValue !== '') {
      try {
        setSearchLoader(true);
        const result = await getOrganizationSearch(searchValue);
        setStartDate('');
        const orgId = result.data.organizationId;
        setOrganizationId(orgId);

        void fetchContributionCycle(orgId);
      } catch (error) {
        console.error('Error fetching organization search results:', error);
        setAdminContributionUploadError(error?.response?.data?.message);
        setStartDate('');
        setFrequency('');
        setOrgName('');
        setSearchLoader(false);
      }
    }
  };

  const uploadEmployeeContributionFile = async (file: File): Promise<void> => {
    try {
      if (file) {
        const id = orgId || organizationId;
        if (id) {
          setFileUploadProgress(true);
          const data = {
            file,

            empId,
            isPreview: !isModalOpen,
            startDate,
            // endDate,
          };
          // const data = { file, empId };
          const result = await uploadContributionFile(id, data);
          if (result?.preview) {
            setIsModalOpen(true);
            setPreviewData(result?.preview);
          }

          if (isModalOpen) {
            void totalContributionOfOrganization(id);
            void organizationContributionFiles(id);
            setFileUploadProgress(false);
            setIsModalOpen(false);
            setPreviewData([]);
            dispatch(
              setSnackBarSuccess({
                snackBarMessage: strings.displayText.uploadSuccessMessage,
              }),
            );
          }
          setLoader(false);
        } else {
          setUploadErrorMessage(strings.displayText.uploadFailedMessage);
          dispatch(
            setSnackBarFailed({
              snackBarMessage: strings.displayText.uploadFailedMessage,
            }),
          );
          setIsModalOpen(false);
          setPreviewData([]);
          setLoader(false);
        }
      }
    } catch (error: unknown) {
      setFileUploadProgress(false);
      setLoader(false);
      if (error?.response.data.data) {
        setOpenUploadError(true);
        setUploadErrorMessage(error.response.data.message);
        setEmployerAdminData(error.response.data.data);
        setTotalEntery(error.response.data.count);
      } else {
        setUploadErrorMessage(error.response.data.message);
        dispatch(
          setSnackBarFailed({ snackBarMessage: error.response.data.message }),
        );
      }
    }
  };

  const organizationContributionFiles = async (id: number): Promise<void> => {
    try {
      const res = (await getOrganizationContributionFiles(
        id,
        Number(pageInfo?.page) + 1,
        pageInfo?.pageSize,
        searchValue,
        Boolean(deletedTab),
      )) as { basicInfo: contributionFilesType };
      setContributionFiles(res?.basicInfo?.rows);
      setPageCount(res?.basicInfo?.count);
    } catch (error) {
      console.log(error);
    }
  };

  const allOrganizationContributionFiles = async (
    searchValue: string,
    filters: any,
  ): Promise<void> => {
    try {
      let res;
      const updatedFilters = {
        ...filters,
        deleted: deletedTab ? 'true' : 'false',
      };
      if (deletedTab) {
        res = (await getAllOrganizationContributionFiles(
          Number(pageInfo?.page) + 1,
          pageInfo?.pageSize,
          pageInfo?.sortBy,
          pageInfo?.sortOrder,
          searchValue,
          updatedFilters,
        )) as {
          basicInfo: contributionFilesType;
        };
      } else {
        res = (await getAllOrganizationContributionFiles(
          Number(pageInfo?.page) + 1,
          pageInfo?.pageSize,
          pageInfo?.sortBy,
          pageInfo?.sortOrder,
          searchValue,
          filters,
          false,
        )) as {
          basicInfo: contributionFilesType;
        };
      }
      setContributionFiles(res?.basicInfo?.rows);
      setPageCount(res?.basicInfo?.count);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (roles[0] === allRoles.OrganizationAdminRole && orgId) {
      void totalContributionOfOrganization(orgId);
    }
  }, [orgId, roles[0]]);

  useEffect(() => {
    if (roles[0] === allRoles.OrganizationAdminRole && orgId) {
      void organizationContributionFiles(orgId);
    } else if (roles[0] !== allRoles.OrganizationAdminRole) {
      void allOrganizationContributionFiles(searchValue, filters);
    }
  }, [
    orgId,
    pageInfo?.page,
    pageInfo?.pageSize,
    searchValue,
    pageInfo?.sortBy,
    pageInfo?.sortOrder,
  ]);

  useEffect(() => {
    if (employerAdminData?.length > 0) {
      setErrData(employerAdminData);
      setFinalizedData(employerAdminData);
    }
  }, [employerAdminData]);
  useEffect(() => {
    if (orgId) {
      getOrganizationDetailsOrgId(Number(orgId))
        .then((res) => {
          dispatch(setOrganizationInfo(res));
        })
        .catch((err: Error) => {
          console.log(err);
        });
    }
  }, [orgId]);

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const fetchContributionCycle = async (organizationId?: number) => {
    try {
      const id = organizationId ?? orgId;
      const data = await getContributionFrequency(id);
      setAdminContributionUploadError('');
      setStartDate(data.startDate || '');
      setFrequency(data.frequency || '');
      setOrgName(data.name || '');
      setSearchLoader(false);
    } catch (err) {
      console.error('Error fetching contribution cycle:', err);
    }
  };

  const handleDeleteDialogClose = (): void => {
    setOpenDeleteDialog(false);
  };
  // Not Needed Now
  // const handleNotifyDialogClose = (): void => {
  //   setOpenNotifyDialog(false);
  // };
  const handleRemoveDialogClose = (): void => {
    setOpenRemoveDialog(false);
  };

  const handleDelete = async (): Promise<void> => {
    setOpenDeleteDialog(false);
    const newData = errData.filter(
      (item) => item.indexs !== removeErrorData?.indexs,
    );

    setErrData(newData);
    setFinalizedData(newData);
    setRemoveErrorData('');
  };

  const handleRemove = async (): Promise<void> => {
    setOpenRemoveDialog(false);
    const newData = errData.filter(
      (item) => item.Email !== removeErrorData?.Email,
    );

    setErrData(newData);
    setFinalizedData(newData);
    setRemoveErrorData('');
  };

  const handleRemoveAllNonOnboarded = (): void => {
    const nonOnboardedUsers = errData.filter(
      (item) =>
        item.errorType === strings.displayText.notboardedErrorType ||
        item.errorType === strings.displayText.onboardingErrorType,
    );

    const remainingData = errData.filter(
      (item) =>
        item.errorType !== strings.displayText.notboardedErrorType &&
        item.errorType !== strings.displayText.onboardingErrorType,
    );

    setErrData(remainingData);
    setFinalizedData(remainingData);

    dispatch(
      setSnackBarSuccess({
        snackBarMessage: `Removed ${nonOnboardedUsers.length} non-onboarded users from the upload`,
      }),
    );
  };

  const handleProceedWithFinalizedData = async (): Promise<void> => {
    try {
      setUploadLoader(true);
      if (finalizedData.length === 0) {
        dispatch(
          setSnackBarFailed({
            snackBarMessage: 'No valid data to proceed with upload',
          }),
        );
        setUploadLoader(false);
        return;
      }

      const updatedData = finalizedData.map(({ errorType, error, ...rest }) =>
        errorType === 'AVCpensioner'
          ? { ...rest } // `amount` removed
          : { ...rest, errorType, error },
      );
      const data = {
        file: file as File,
        empId: String(empId),
        isPreview: false,
        startDate,
        // endDate,
        finalizedData: updatedData,
      };
      const id = orgId || organizationId;
      const result = (await uploadContributionFile(id, data)) as any;
      if (result) {
        setOpenUploadError(false);
        setUploadErrorMessage('');
        setOpenUploadOptions(false);
        setShowDecimalError(false);
        void totalContributionOfOrganization(id);
        if (roles && roles[0] === allRoles.OrganizationAdminRole) {
          void organizationContributionFiles(orgId);
        } else if (
          roles &&
          (roles[0] === allRoles.MMEmployeeRole ||
            roles[0] === allRoles.MMAdminRole)
        ) {
          void allOrganizationContributionFiles(searchValue, filters);
        }
        setFileUploadProgress(false);
        setIsModalOpen(false);
        setPreviewData([]);
        setStartDate('');
        // setEndDate('');
        setFile(null);
        dispatch(
          setSnackBarSuccess({
            snackBarMessage: strings.displayText.uploadSuccessMessage,
          }),
        );
      }
      setUploadLoader(false);
    } catch (error: unknown) {
      setFileUploadProgress(false);
      setUploadLoader(false);
    }
  };

  // Not Needed Now
  // const handleNotify = async (): Promise<void> => {
  //   if (notifyData) {
  //     const email = notifyData?.Email;
  //     const errorType = notifyData?.errorType;
  //     const data: { email: string; errorType: string } = { email, errorType };
  //     const res = await onboardNotifyEmployee(data);
  //     if (res) {
  //       dispatch(
  //         setSnackBarSuccess({
  //           snackBarMessage: strings.displayText.notificationSucessMessage,
  //         }),
  //       );
  //     } else {
  //       dispatch(
  //         setSnackBarFailed({
  //           snackBarMessage: strings.displayText.notificationFailedMessage,
  //         }),
  //       );
  //     }
  //   }
  //   setOpenNotifyDialog(false);
  // };

  const handleApplyFilter = async (): Promise<void> => {
    if (orgId) {
      filters.orgId = orgId;
    }
    dispatch(setCurrentPage({ key: 'contributions', value: 0 }));
    void allOrganizationContributionFiles(searchValue || '', filters);
  };

  const handleExportContributionData = async (): Promise<void> => {
    try {
      setLoading(true);

      const url =
        roles && roles[0] === allRoles.OrganizationAdminRole && orgId
          ? await exportMyOrganizationContributionFiles(
              orgId,
              searchValue,
              filters,
            )
          : await exportAllOrganizationContributionFiles(searchValue, filters);
      setLoading(false);
      const link = document.createElement('a');
      link.href = url as string;
      link.download = `ContributionFile_${new Date().toString()}.xlsx`;
      link.click();
      dispatch(
        setSnackBarSuccess({
          snackBarMessage: strings.displayText.contributionDataExportSuccess,
        }),
      );
    } catch (error) {
      console.log(error);
      setLoading(false);
      dispatch(
        setSnackBarSuccess({
          snackBarMessage: strings.displayText.contributionDataExportFailed,
        }),
      );
    }
  };

  const getContributionStatus = (status: string): string => {
    switch (status) {
      case 'Success':
        return strings.displayText.reconciled;
      case 'Pending':
        return strings.displayText.nonReconciledPending;
      case 'Rejected':
        return strings.displayText.nonReconciledRejected;
      default:
        return '-';
    }
  };

  const handleDownload = async (row: contributionFilesType): Promise<void> => {
    try {
      const data = (await getContributionFile(row.key)) as string;

      const link = document.createElement('a');
      link.href = data;
      link.download = row.fileName;
      document.body.appendChild(link);
      link.click();

      // Clean up the link
      document.body.removeChild(link);
    } catch (error) {
      console.log(error);
    }
  };

  const handleContributionDownload = async (): Promise<void> => {
    try {
      const id = orgId || organizationId;
      const { url, filename } = await getAllRegisterOrgEmployee(
        id,
        startDate,
        organizationInfo?.payrollFrequency ?? frequency,
        // endDate,
      );
      if (url && filename) {
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  const handleDeleteFileDialogClose = (): void => {
    setOpenDeleteFileDialog(false);
    setContributionFileData('');
  };

  const handleDeleteFile = async (): Promise<void> => {
    if (contributionFileData) {
      const contData = {
        contributionFileId: contributionFileData.contributionFileId,
        key: contributionFileData.key,
        empId,
      };
      await deleteContributionFile(contData)
        .then((res: any) => {
          dispatch(
            setSnackBarSuccess({
              snackBarMessage: res.message,
            }),
          );
          setOpenDeleteFileDialog(false);
          setContributionFileData('');
          void organizationContributionFiles(orgId);
          void totalContributionOfOrganization(orgId);
        })
        .catch((error: any) => {
          console.log(error);
          dispatch(
            setSnackBarFailed({
              snackBarMessage:
                strings.displayText.uploadFileDeleteFailedMessage,
            }),
          );
        });
    }
  };

  const handleRowClick = (row: contributionFilesType): void => {
    if (!openDeleteFileDialog) {
      setSelectedContributionFile(row);
      setIsOpenContributionFileData(true);
    }
  };

  const handleCancelFile = (): void => {
    setOpenUploadOptions(false);
    setShowDecimalError(false);
    setOpenUploadSubOptions(false);
    setStartDate('');
    // setEndDate('');
    setUploadErrorMessage('');
    setFile(null);
    void totalContributionOfOrganization(orgId);
    void organizationContributionFiles(orgId);
    setFileUploadProgress(false);
    setIsModalOpen(false);
    setPreviewData([]);
    setLoader(false);
    setDateError('');
  };

  const resetUploadState = (): void => {
    setOpenUploadOptions(false);
    setShowDecimalError(false);
    setOpenUploadSubOptions(false);
    setFileUploadProgress(false);
    setIsModalOpen(false);
    setPreviewData([]);
    setFile(null);
    setUploadErrorMessage('');
    setLoader(false);
    setDateError('');
    setStartDate('');
    // setEndDate('');
    setErrData([]);
    setFinalizedData([]);
    setEmployerAdminData([]);
  };

  const [filters, setFilters] = useState<any>({
    startDate: null,
    endDate: null,
    frequencyType: '',
    status: '',
  });
  const handleFilterChange = (filterType: string, value: string): void => {
    setFilters({
      ...filters,
      [filterType]: value,
    });
  };

  const handleHideDeletedAction = (row: any): boolean => {
    if (deletedTab) return true;
    return row?.deleted;
  };

  const customStyles = {
    textWrap: {
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      maxWidth: '100%',
    },
    cursorStyle: { cursor: 'pointer' },
    maxWidthStyle: {
      maxWidth: '100%',
    },
  };

  const hasBlockingOnboardingErrors = errData.some(
    (item) =>
      item.errorType === strings.displayText.notboardedErrorType ||
      item.errorType === strings.displayText.onboardingErrorType,
  );
  const hasVestedEntries = errData.some(
    (item) => item.errorType === strings.displayText.vestedAccountErrorType,
  );

  const hasLeaverError = errData.some(
    (item) => item.errorType === strings.displayText.leaverErrorType,
  );
  const hasEmployeeOver65YrsOld = errData.some(
    (item) => item.errorType === strings.displayText.over65YearsErrorType,
  );
  const disableContributionUpload =
    hasBlockingOnboardingErrors ||
    hasVestedEntries ||
    hasEmployeeOver65YrsOld ||
    hasLeaverError;

  const columns: GridColumns<GridValidRowModel> = [
    {
      field: 'firstName',
      flex: 1.3,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.firstName}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Tooltip title={row?.['First Name']} placement="top">
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {row['First Name']}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'lastName',
      flex: 1.2,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.lastName}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Tooltip title={row['Last Name']} placement="top">
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {row['Last Name']}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'email',
      flex: 2.5,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.emailAddress}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Tooltip title={row?.Email} placement="top">
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {row?.Email}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'employerContribution',
      flex: 2,
      align: 'right',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.employerContribution}
        </Typography>
      ),

      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row['Employer Contribution']}
        </Typography>
      ),
    },
    {
      field: 'employeeContribution',
      flex: 2,
      align: 'right',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.employeeContribution}
        </Typography>
      ),

      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row['Employee Contribution']}
        </Typography>
      ),
    },
    {
      field: 'comments',
      minWidth: 300,
      flex: 2,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.comments}
        </Typography>
      ),

      renderCell: ({ row }) => (
        <Typography
          variant="h4"
          color={colors.primaryRed[100]}
          fontSize={12}
          sx={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {row?.error ? row?.error : '-'}
        </Typography>
      ),
    },
    {
      field: 'actions',
      flex: 2,
      headerAlign: 'center',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.actionsColumn}
        </Typography>
      ),

      renderCell: ({ row }) => (
        <Box m="0 auto" p="5px" display="flex" justifyContent="space-evenly">
          {row.errorType === 'duplicateEntery' ? (
            <Chip
              label={strings.displayText.deleteEntryLabel}
              variant="outlined"
              color="error"
              onClick={() => {
                setOpenDeleteDialog(true);
                setRemoveErrorData(row);
              }}
              icon={<DeleteIcon />}
            />
          ) : row.errorType === 'notRegister' ? (
            <Chip
              label={strings.displayText.addEmpoyeeLabel}
              variant="outlined"
              color="success"
              onClick={() => {
                navigate('/employees?openAddEmployee=true');
              }}
              icon={<AddIcon />}
            />
          ) : row?.errorType === strings.displayText.notboardedErrorType ||
            row?.errorType === strings.displayText.onboardingErrorType ? (
            <>
              <Box sx={{ padding: '1%' }}></Box>
              <Chip
                label={strings.displayText.removeLabel}
                variant="outlined"
                color="error"
                onClick={() => {
                  setOpenRemoveDialog(true);
                  setRemoveErrorData(row);
                }}
                icon={<DeleteIcon />}
              />
            </>
          ) : row?.errorType === strings.displayText.vestedAccountErrorType ||
            row.errorType === strings.displayText.over65YearsErrorType ||
            row.errorType === strings.displayText.leaverErrorType ? (
            <Chip
              label={strings.displayText.removeLabel}
              variant="outlined"
              color="warning"
              onClick={() => {
                setOpenRemoveDialog(true);
                setRemoveErrorData(row);
              }}
              icon={<DeleteIcon />}
            />
          ) : (
            '-'
          )}
        </Box>
      ),
    },
  ];

  const allOrganiztionContributionFilesColumns: GridColumns<GridValidRowModel> =
    [
      {
        field: 'organizationId',
        width: 150,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.organizationId}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {row.organizationId}
          </Typography>
        ),
      },
      {
        field: 'uniqueId',
        width: 150,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.employersID}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {row.organizationInfo.uniqueId}
          </Typography>
        ),
      },
      {
        field: 'contributionFileId',
        width: 150,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.fileId}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {row.contributionFileId}
          </Typography>
        ),
      },
      {
        field: 'createdAt',
        width: 200,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.dateOfFileUpload}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {row.uploadDate}
          </Typography>
        ),
      },
      {
        field: 'companyName',
        width: 150,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.companyName}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {row.organizationInfo?.companyName}
          </Typography>
        ),
      },
      {
        field: 'email',
        width: 240,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.email}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.cursorStyle,
            }}
          >
            {row.organizationInfo?.regEmail}
          </Typography>
        ),
      },
      {
        field: 'deleted',
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.deleted}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{ textAlign: 'center' }}
          >
            {row?.deleted ? 'Yes' : 'No'}
          </Typography>
        ),
      },
      {
        field: 'frequencyType',
        width: 150,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.frequencyType}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {
              payrollFrequencyOptions.find(
                (option) => option.value === row.frequencyType,
              )?.label
            }
          </Typography>
        ),
      },
      {
        field: 'periodDate',
        width: 200,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.payrollDateLabel}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.cursorStyle,
            }}
          >
            {row?.period}
          </Typography>
        ),
      },
      {
        field: 'amount',
        width: 150,
        sortable: false,
        cellClassName: 'name-column--cell',
        align: 'right',
        headerAlign: 'right',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.amountLabel}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {CurrencyFormaterTwoDecimals(JSON.parse(row?.totalContribution))}
          </Typography>
        ),
      },
      {
        field: 'status',
        width: 150,
        align: 'right',
        headerAlign: 'right',
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.status}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {row?.deleted ? (
              <>{strings.displayText.deleted}</>
            ) : (
              getContributionStatus(row?.status)
            )}
          </Typography>
        ),
      },
    ];
  const allOrganiztionContributionFilesColumnsDeleted: GridColumns<GridValidRowModel> =
    [
      {
        field: 'organizationId',
        width: 150,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.organizationId}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {row.organizationId}
          </Typography>
        ),
      },
      {
        field: 'uniqueId',
        width: 150,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.employersID}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {row.organizationInfo.uniqueId}
          </Typography>
        ),
      },
      {
        field: 'contributionFileId',
        width: 150,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.fileId}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {row.contributionFileId}
          </Typography>
        ),
      },
      {
        field: 'createdAt',
        width: 200,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.dateOfFileUpload}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {row.uploadDate}
          </Typography>
        ),
      },
      {
        field: 'companyName',
        width: 150,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.companyName}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {row.organizationInfo?.companyName}
          </Typography>
        ),
      },
      {
        field: 'email',
        width: 240,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.email}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.cursorStyle,
            }}
          >
            {row.organizationInfo?.regEmail}
          </Typography>
        ),
      },
      {
        field: 'deletedBy',
        cellClassName: 'name-column--cell',
        width: 150,
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.deletedBy}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{ textAlign: 'center' }}
          >
            {row?.deletedByEmployee?.fullName}
          </Typography>
        ),
      },
      {
        field: 'deletedAt',
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.deletedAt}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{ textAlign: 'center' }}
          >
            {formatDate(row?.deletedAt)}
          </Typography>
        ),
      },
      {
        field: 'frequencyType',
        width: 150,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.frequencyType}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {
              payrollFrequencyOptions.find(
                (option) => option.value === row.frequencyType,
              )?.label
            }
          </Typography>
        ),
      },
      {
        field: 'periodDate',
        width: 200,
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.payrollDateLabel}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.cursorStyle,
            }}
          >
            {row?.period}
          </Typography>
        ),
      },
      {
        field: 'amount',
        width: 150,
        sortable: false,
        cellClassName: 'name-column--cell',
        align: 'right',
        headerAlign: 'right',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.amountLabel}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {CurrencyFormaterTwoDecimals(JSON.parse(row?.totalContribution))}
          </Typography>
        ),
      },
      {
        field: 'status',
        width: 150,
        align: 'right',
        headerAlign: 'right',
        cellClassName: 'name-column--cell',
        renderHeader: () => (
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {strings.displayText.status}
          </Typography>
        ),
        renderCell: ({ row }) => (
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              ...customStyles.textWrap,
              ...customStyles.cursorStyle,
            }}
          >
            {getContributionStatus(row?.status)}
          </Typography>
        ),
      },
    ];
  const contributionFilesColumns: GridColumns<GridValidRowModel> = [
    {
      field: 'fileName',
      width: 200,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.fileNameLabel}
        </Typography>
      ),
      renderCell: ({ row }) => {
        const fileName: string = row.fileName;
        return (
          <Tooltip title={fileName} placement="top">
            <Typography
              variant="h5"
              color={colors.gray[100]}
              fontSize={14}
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '95%',
                display: 'block',
              }}
            >
              {fileName}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'periodDate',
      width: 220,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.payrollDateLabel}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row.period}
        </Typography>
      ),
    },
    {
      field: 'frequencyType',
      width: 150,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.frequencyType}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={{
            ...customStyles.textWrap,
            ...customStyles.cursorStyle,
          }}
        >
          {
            payrollFrequencyOptions.find(
              (option) => option.value === row.frequencyType,
            )?.label
          }
        </Typography>
      ),
    },

    {
      field: 'fileId',
      width: 100,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.fileId}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={{
            ...customStyles.textWrap,
            ...customStyles.cursorStyle,
          }}
        >
          {row.contributionFileId}
        </Typography>
      ),
    },
    {
      field: 'uploadDate',
      width: 150,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.dateUploadLabel}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row.uploadDate}
        </Typography>
      ),
    },
    {
      field: 'uploadBy',
      width: 150,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.uploadedByLabel}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row?.employeeInfo?.fullName}
        </Typography>
      ),
    },
    {
      field: 'status',
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.status}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row.status}
        </Typography>
      ),
    },
    {
      field: 'deleted',
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.deleted}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={{ textAlign: 'center' }}
        >
          {row?.deleted ? 'Yes' : 'No'}
        </Typography>
      ),
    },
  ];
  const contributionFilesColumnsDeleted: GridColumns<GridValidRowModel> = [
    {
      field: 'fileName',
      width: 200,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.fileNameLabel}
        </Typography>
      ),
      renderCell: ({ row }) => {
        const fileName: string = row.fileName;
        return (
          <Tooltip title={fileName} placement="top">
            <Typography
              variant="h5"
              color={colors.gray[100]}
              fontSize={14}
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '95%',
                display: 'block',
              }}
            >
              {fileName}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'periodDate',
      width: 220,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.payrollDateLabel}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row.period}
        </Typography>
      ),
    },
    {
      field: 'frequencyType',
      width: 150,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.frequencyType}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={{
            ...customStyles.textWrap,
            ...customStyles.cursorStyle,
          }}
        >
          {
            payrollFrequencyOptions.find(
              (option) => option.value === row.frequencyType,
            )?.label
          }
        </Typography>
      ),
    },
    {
      field: 'fileId',
      width: 100,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.fileId}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={{
            ...customStyles.textWrap,
            ...customStyles.cursorStyle,
          }}
        >
          {row.contributionFileId}
        </Typography>
      ),
    },
    {
      field: 'uploadDate',
      width: 150,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.dateUploadLabel}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row.uploadDate}
        </Typography>
      ),
    },
    {
      field: 'uploadBy',
      width: 150,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.uploadedByLabel}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row?.employeeInfo?.fullName}
        </Typography>
      ),
    },
    {
      field: 'deletedAt',
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.deletedAt}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={{ textAlign: 'center' }}
        >
          {formatDate(row?.deletedAt)}
        </Typography>
      ),
    },
    {
      field: 'deletedBy',
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.deletedBy}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={{ textAlign: 'center' }}
        >
          {row?.deletedByEmployee?.fullName}
        </Typography>
      ),
    },

    {
      field: 'status',
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.status}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row.status}
        </Typography>
      ),
    },
    {
      field: 'deleted',
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.deleted}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={{ textAlign: 'center' }}
        >
          {row?.deleted ? 'Yes' : 'No'}
        </Typography>
      ),
    },
  ];

  const previewColumns = [
    {
      field: 'name',
      width: 200,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.name}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={customStyles.textWrap}
        >
          {row.employeeName}
        </Typography>
      ),
    },
    {
      field: 'email',
      width: 250,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.email}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={customStyles.textWrap}
        >
          {row.email}
        </Typography>
      ),
    },
    {
      field: 'previousERContribution',
      width: 200,
      align: 'right',
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.previousERContribution}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={{ ...customStyles.textWrap, textAlign: 'right' }}
        >
          {CurrencyFormaterTwoDecimals(row.previous?.employerContribution || 0)}
        </Typography>
      ),
    },
    {
      field: 'previousEEContribution',
      width: 200,
      align: 'right',
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.previousEEContribution}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={{ ...customStyles.textWrap, textAlign: 'right' }}
        >
          {CurrencyFormaterTwoDecimals(row.previous?.employeeContribution || 0)}
        </Typography>
      ),
    },
    {
      field: 'currentERContribution',
      width: 200,
      align: 'right',
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.currentERContribution}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={{ ...customStyles.textWrap, textAlign: 'right' }}
        >
          {CurrencyFormaterTwoDecimals(row.current?.employerContribution || 0)}
        </Typography>
      ),
    },
    {
      field: 'currentEEContribution',
      width: 200,
      align: 'right',
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.currentEEContribution}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={{ ...customStyles.textWrap, textAlign: 'right' }}
        >
          {CurrencyFormaterTwoDecimals(row.current?.employeeContribution || 0)}
        </Typography>
      ),
    },
    {
      field: 'diffERContribution',
      width: 200,
      align: 'right',
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.diffERContribution}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={{ ...customStyles.textWrap, textAlign: 'right' }}
        >
          {CurrencyFormaterTwoDecimals(
            row.difference?.employerContribution || 0,
          )}
        </Typography>
      ),
    },
    {
      field: 'diffEEContribution',
      width: 200,
      align: 'right',
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.diffEEContribution}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          sx={{ ...customStyles.textWrap, textAlign: 'right' }}
        >
          {CurrencyFormaterTwoDecimals(
            row.difference?.employeeContribution || 0,
          )}
        </Typography>
      ),
    },
  ];

  const columnsToRender =
    orgId && roles[0] === allRoles.OrganizationAdminRole
      ? deletedTab
        ? contributionFilesColumnsDeleted
        : contributionFilesColumns
      : deletedTab
      ? allOrganiztionContributionFilesColumnsDeleted
      : allOrganiztionContributionFilesColumns;

  return (
    <Box>
      <Box display={'flex'} justifyContent={'space-between'}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="flex-end"
          className="mb-5"
          sx={{ marginTop: '5px', marginBottom: '5px' }}
        >
          <Grid sx={{ minWidth: 100, marginTop: 2, marginRight: 1 }}>
            <TextField
              label={strings.displayText.startDateFileUploadLabel}
              type="date"
              value={filters.startDate}
              onChange={(e) => {
                handleFilterChange('startDate', e.target.value);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid sx={{ minWidth: 100, marginTop: 2, marginRight: 1 }}>
            <TextField
              label={strings.displayText.endDateFileUploadLabel}
              type="date"
              value={filters.endDate}
              onChange={(e) => {
                handleFilterChange('endDate', e.target.value);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid sx={{ minWidth: 200, marginTop: 2, marginRight: 1 }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Frequency Type
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Frequency Type"
                value={filters.frequencyType}
                onChange={(e) => {
                  handleFilterChange('frequencyType', e.target.value);
                }}
              >
                {payrollFrequencyFilterOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {!deletedTab && (
            <Grid sx={{ minWidth: 100, marginTop: 2, marginRight: 1 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select-Status"
                  label="Status"
                  value={filters.status}
                  onChange={(e) => {
                    handleFilterChange('status', e.target.value);
                  }}
                >
                  {contributionFileStatus.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item>
            <LoadingButton
              type="submit"
              fullWidth
              variant="contained"
              loadingPosition="end"
              onClick={() => {
                void handleApplyFilter();
              }}
            >
              {strings.displayText.filter}
            </LoadingButton>
          </Grid>
          {!deletedTab ? (
            <>
              <Grid item>
                <LoadingButton
                  disabled={loading}
                  variant="contained"
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onClick={handleExportContributionData}
                >
                  {strings.displayText.export}
                </LoadingButton>
              </Grid>
            </>
          ) : (
            <></>
          )}
          {!deletedTab &&
          roles &&
          (roles[0] === allRoles.MMEmployeeRole ||
            roles[0] === allRoles.MMAdminRole) ? (
            <>
              <Grid item>
                <LoadingButton
                  disabled={loading}
                  variant="contained"
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onClick={() => {
                    setOrganizationSearch('');
                    setAdminContributionUploadError('');
                    setStartDate('');
                    setFrequency('');
                    setOrgName('');
                    setSearchLoader(false);
                    setOpenAdminContributionUpload(true);
                  }}
                >
                  {strings.displayText.uploadContributionLabel}
                </LoadingButton>
              </Grid>
            </>
          ) : (
            <></>
          )}
        </Grid>
      </Box>
      {orgId && roles[0] === allRoles.OrganizationAdminRole && !deletedTab ? (
        <Card
          elevation={2}
          sx={{
            px: 5,
            py: 2,
            my: 2,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Box display={'flex'} flexDirection={'column'}>
            <Typography
              sx={{ py: 1 }}
              component="h1"
              variant="h5"
              fontSize="16px"
              fontFamily={['Inter']}
              color="#898989"
            >
              {strings.displayText.totalContributionLabel} :{' '}
            </Typography>
            <Typography
              component="h1"
              variant="h5"
              fontFamily={['Inter']}
              fontWeight={700}
              fontSize="28px"
            >
              {' '}
              {CurrencyFormaterTwoDecimals(Number(totalContribution))}
            </Typography>
          </Box>
          <Box display={'flex'} flexDirection={'column'}>
            <Typography
              sx={{ py: 1 }}
              component="h1"
              variant="h5"
              fontSize="16px"
              fontFamily={['Inter']}
              color="#898989"
            >
              {strings.displayText.upcomingContributionLabel} :{' '}
            </Typography>
            <Typography
              component="h1"
              variant="h5"
              fontFamily={['Inter']}
              fontWeight={700}
              fontSize="28px"
            >
              {CurrencyFormaterTwoDecimals(Number(upComingContribution))}
            </Typography>
          </Box>
          <Buttons
            sx={{
              height: 50,
              width: 250,
              bgcolor: colors.greenAccent[500],
              borderRadius: 2,
              alignSelf: 'center',
            }}
            onClick={() => {
              setStartDate('');
              setOpenUploadOptions(true);
              void fetchContributionCycle();
            }}
          >
            {strings.displayText.uploadContributionLabel}
          </Buttons>
        </Card>
      ) : null}
      <Box style={{ marginTop: 10 }}>
        <CustomDataGrid
          currentPage={commonConstantTexts.contributionsPage}
          columns={columnsToRender}
          rows={contributionFiles}
          getRowId={(row: GridRowData) => `${String(row.contributionFileId)}`}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? commonConstantTexts.evenText
              : commonConstantTexts.oddText
          }
          onActionBtnClick2={(row, event) => {
            event.stopPropagation();
            setContributionFileData(row);
            setOpenDeleteFileDialog(true);
          }}
          actionBtnText2={
            orgId && roles[0] === allRoles.OrganizationAdminRole
              ? strings.displayText.delete
              : ''
          }
          ActionBtnIcon2={() => <DeleteIcon />}
          actionBtnText1={
            orgId && roles[0] === allRoles.OrganizationAdminRole
              ? strings.displayText.downloadLabel
              : ''
          }
          ActionBtnIcon1={() => <DownloadIcon />}
          onActionBtnClick1={(row, event) => {
            event.stopPropagation();
            void handleDownload(row);
          }}
          onRowClick={handleRowClick}
          pageCount={pageCount}
          searchEnabled={true}
          handleSearch={handleSearch}
          searchPlaceholder={
            orgId && roles[0] === allRoles.OrganizationAdminRole
              ? strings.displayText.searchLabel11
              : strings.displayText.searchLabel3
          }
          hideActionBtnIcon2={(row) => handleHideDeletedAction(row)}
          sortModel={checkSortingValues(pageInfo)}
          sortingMode={strings.displayText.sortingServer}
          onSortModelChange={(mode: any) => {
            dispatch(
              setSortBy({
                key: commonConstantTexts.contributionsPage,
                value: mode[0].field,
              }),
            );
            dispatch(
              setSortOrder({
                key: commonConstantTexts.contributionsPage,
                value: mode[0].sort,
              }),
            );
            dispatch(
              setCurrentPage({
                key: commonConstantTexts.contributionsPage,
                value: 0,
              }),
            );
          }}
        />
      </Box>
      <Dialog
        open={openUploadOptions}
        onClose={() => {
          resetUploadState();
        }}
        PaperProps={{
          sx: {
            mt: -6,
          },
        }}
      >
        <DialogTitle
          sx={{ fontFamily: 'Inter', fontSize: '20px', color: '#000' }}
        >
          {`${strings.displayText.contributionsforText} ${orgName || ''}`}:
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{ display: 'flex', gap: 2, justifyContent: 'space-between' }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              {/* Start Date */}
              <DatePicker
                label={'Payroll Date'}
                format="DD/MM/YYYY"
                value={startDate ? dayjs(startDate) : null}
                onChange={(newValue) => {
                  if (!newValue) return;
                  const newStart = newValue.format('YYYY-MM-DD');
                  setStartDate(newStart);
                }}
                sx={{ m: 1, minWidth: 200 }}
                slotProps={{
                  textField: {
                    error: !!dateError,
                    helperText: dateError,
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          {openUploadSuboptions && (
            <Box display={'flex'} flexDirection={'column'} m={1} py={1}>
              <Button
                sx={{ p: 1, m: 1 }}
                variant="outlined"
                onClick={() => {
                  setDownloadFormat(true);
                  void handleContributionDownload();
                }}
                startIcon={<DownloadIcon />}
              >
                <a
                  style={{ textDecoration: 'none', color: '#000' }}
                  target="_blank"
                  download
                  rel="noreferrer"
                >
                  {strings.displayText.downloadFormatLabel}
                </a>
              </Button>
              {downloadFormat && (
                <LoadingButton
                  loading={fileUploadProgress}
                  variant="outlined"
                  component="label"
                  sx={{ p: 1, m: 1 }}
                  startIcon={<UploadIcon />}
                >
                  {strings.displayText.uploadFile}
                  <input
                    // eslint-disable-next-line @typescript-eslint/no-misused-promises
                    onChange={async (e: ChangeEvent<HTMLInputElement>) => {
                      if (e.target.files) {
                        const f = e.target.files[0];
                        const isValid = await ValidateContributionFile(f);
                        if (isValid) {
                          setShowDecimalError(false);
                          setFile(f);
                          void uploadEmployeeContributionFile(f);
                          setOpenUploadSubOptions(false);
                        } else {
                          setShowDecimalError(true);
                        }
                      }
                    }}
                    hidden
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    type="file"
                  />
                </LoadingButton>
              )}
              {showDecimalError && (
                <span
                  style={{
                    color: '#d32f2f',
                    fontSize: '14px',
                    fontWeight: '500',
                  }}
                >
                  {strings.displayText.contributionFileDecimalError}
                </span>
              )}
            </Box>
          )}
          {fileUploadProgress && (
            <Box sx={{ m: 2 }}>
              <LinearProgress />
              <Typography sx={{ mt: 1 }}>Uploading...</Typography>
            </Box>
          )}
          {file && !fileUploadProgress && !uploadErrorMessage ? (
            <Box display={'flex'} flexDirection={'column'}>
              <Typography sx={{ m: 2, alignSelf: 'center', fontWeight: '700' }}>
                {file?.name}
              </Typography>
              <Buttons
                variant="text"
                onClick={() => {
                  resetUploadState();
                }}
                sx={{ color: colors.greenAccent[500], alignSelf: 'flex-end' }}
              >
                {strings.displayText.closeLable}
              </Buttons>
            </Box>
          ) : (
            <Typography sx={{ color: 'red', m: 1 }}>
              {uploadErrorMessage}
            </Typography>
          )}
        </DialogContent>
        {!file && (
          <DialogActions>
            <Buttons
              onClick={() => {
                resetUploadState();
              }}
              variant="text"
              sx={{}}
            >
              {strings.displayText.cancel}
            </Buttons>
            <Buttons
              disabled={startDate === '' || !!dateError}
              onClick={() => {
                setOpenUploadSubOptions(true);
              }}
              variant="text"
              sx={{ color: colors.greenAccent[500], fontWeight: 'bold' }}
            >
              {strings.displayText.okText}
            </Buttons>
          </DialogActions>
        )}
        {uploadErrorMessage && (
          <DialogActions>
            <Button
              onClick={() => {
                setFile(null);
                setUploadErrorMessage('');
                setOpenUploadSubOptions(true);
              }}
              startIcon={<RefreshIcon />}
              variant="text"
              sx={{ color: colors.greenAccent[500], fontWeight: 'bold' }}
            >
              {strings.displayText.tryAgain}
            </Button>
          </DialogActions>
        )}
      </Dialog>
      <DialogBox
        open={openUploadError}
        onClose={() => {
          setOpenUploadError(false);
          resetUploadState();
        }}
        fullWidth={true}
        screenWidth="xl"
        title={strings.displayText.fileNotUplaod}
      >
        <DialogContent>
          <Box
            component="form"
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-between',
            }}
          >
            <Typography></Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <LoadingButton
                variant="outlined"
                color="warning"
                onClick={handleRemoveAllNonOnboarded}
                disabled={!hasBlockingOnboardingErrors}
                startIcon={<DeleteIcon />}
              >
                {strings.displayText.removeAllNonOnboarded}
              </LoadingButton>
              <LoadingButton
                loading={uploadLoader}
                disabled={disableContributionUpload}
                variant="contained"
                color="success"
                loadingPosition="start"
                onClick={() => {
                  void handleProceedWithFinalizedData();
                }}
                startIcon={<UploadIcon />}
              >
                {strings.displayText.continueText}
              </LoadingButton>
            </Box>
            {hasVestedEntries && (
              <Alert severity="warning" sx={{ mt: 2 }}>
                {strings.displayText.vestedAccountContributionBlocked}
              </Alert>
            )}
            {hasEmployeeOver65YrsOld && (
              <Alert severity="warning" sx={{ mt: 2 }}>
                {strings.displayText.employeeOver65YrsBlocked}
              </Alert>
            )}
          </Box>
          <Box>
            <CustomDataGrid
              currentPage={strings.displayText.contributions}
              columns={columns}
              rows={errData}
              getRowId={(row: GridRowData) =>
                // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
                `${String(row.Email)}${row.Email ? row.Email : ''}`
              }
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? commonConstantTexts.evenText
                  : commonConstantTexts.oddText
              }
              pageCount={totalEntery}
            />
          </Box>
        </DialogContent>
      </DialogBox>

      <DeleteEntryModal
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        handleDelete={handleDelete}
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        title={`Multiple entries found for${removeErrorData['First Name']},${removeErrorData?.Email} ,${removeErrorData['Phone Number']} ,${removeErrorData['Employer Contribution']},${removeErrorData['Employee Contribution']}`}
      />
      {/*  Not Needed Now */}
      {/* <YesNoModal
        open={openNotifyDialog}
        onClose={handleNotifyDialogClose}
        handleConfirm={handleNotify}
        title={strings.displayText.notifyEmployeeTitle}
      /> */}
      <YesNoModal
        open={openRemoveDialog}
        onClose={handleRemoveDialogClose}
        handleConfirm={handleRemove}
        title={strings.displayText.removeEntryTitle}
      />
      <DeleteEntryModal
        open={openDeleteFileDialog}
        onClose={handleDeleteFileDialogClose}
        handleDelete={handleDeleteFile}
        title={strings.displayText.confrimToDelete}
      />
      <DialogBox
        open={isOpenContributionFileData}
        onClose={() => {
          setIsOpenContributionFileData(false);
        }}
        fullWidth={true}
        title={strings.displayText.contributionFileDetails}
      >
        <ContributionFileGrid contributionFile={selectedContributionFile} />
      </DialogBox>
      {isModalOpen && (
        <DialogBox
          open={isModalOpen}
          onClose={() => {
            resetUploadState();
          }}
          fullWidth={true}
          screenWidth="xl"
          title={strings.displayText.contributionFileDetails}
        >
          <Box>
            <CustomDataGrid
              columns={previewColumns}
              rows={previewData}
              getRowId={(row: GridRowData) =>
                // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
                `${String(row.email)}}`
              }
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? commonConstantTexts.evenText
                  : commonConstantTexts.oddText
              }
            />
          </Box>
          <DialogActions>
            <Buttons
              onClick={() => {
                handleCancelFile();
              }}
              variant="contained"
              sx={{
                m: 1,
                bgcolor: colors.gray[900],
                borderRadius: 2,
              }}
            >
              <Typography
                component="h1"
                variant="h5"
                style={{
                  fontSize: '12px',
                  padding: '3px',
                  color: colors.primaryBg[700],
                }}
              >
                {strings.displayText.cancel}
              </Typography>
            </Buttons>
            <Buttons
              endIcon={loader ? <CircularProgress size={15} /> : null}
              disabled={loader}
              onClick={() => {
                setLoader(true);
                void uploadEmployeeContributionFile(file);
              }}
            >
              <Typography
                component="h1"
                variant="h5"
                style={{ fontSize: '12px' }}
              >
                {strings.displayText.continueText}
              </Typography>
            </Buttons>
          </DialogActions>
        </DialogBox>
      )}
      <ContributionDialog
        open={adminContributionUpload}
        onClose={() => {
          setOpenAdminContributionUpload(false);
          setOrganizationSearch('');
          setAdminContributionUploadError('');
          setStartDate('');
          setFrequency('');
          setOrgName('');
          setSearchLoader(false);
        }}
        searchValue={organizationSearch}
        setSearchValue={setOrganizationSearch}
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        handleSearch={handleSearchOrganizationDetails}
        adminContributionUploadError={adminContributionUploadError}
        orgName={orgName}
        loading={searchLoader}
        handleProceed={handleProceedAdminContributionUpload}
      />
    </Box>
  );
};

export default ContributionFile;
